<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>投诉管理</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <myTableSearch :isOperate="true" :operateWidth="350" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows">
				<template slot="policyLabelList" slot-scope="scope">
					<span v-if="scope.row.policyLabelList && scope.row.policyLabelList.length > 0">
						<span v-for="(item, index) in scope.row.policyLabelList" :key="index">
							{{ item.labelName || item }}
							<span v-if="index < scope.row.policyLabelList.length - 1">、</span>
						</span>
					</span>
					<span v-else>-</span>
				</template>
				<template slot="link" slot-scope="scope">
					<a v-if="scope.row.link" :href="scope.row.link" target="_blank" class="link-text">{{ scope.row.link }}</a>
					<span v-else>-</span>
				</template>
				<template slot="disposeStatus" slot-scope="scope">
					<el-tag 
						:style="{ 
							backgroundColor: getDisposeStatusColor(scope.row.disposeStatus),
							borderColor: getDisposeStatusColor(scope.row.disposeStatus),
							color: '#fff'
						}"
						size="small"
					>
						{{ getDisposeStatusText(scope.row.disposeStatus) }}
					</el-tag>
				</template>
				<template slot="caseStatus" slot-scope="scope">
					<el-tag 
						:style="{ 
							backgroundColor: getCaseStatusColor(scope.row.caseStatus),
							borderColor: getCaseStatusColor(scope.row.caseStatus),
							color: '#fff'
						}"
						size="small"
					>
						{{ getCaseStatusText(scope.row.caseStatus) }}
					</el-tag>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleView(scope.row)" size="small" type="text">查看</el-button>
					<el-button v-hasPerm="'enterprise:dispose:edit'" v-if="scope.row.disposeStatus != '2'"  @click="handleDispose(scope.row)" size="small" type="text">处理</el-button>
                    <el-button v-hasPerm="'enterprise:case:edit'" v-if=" scope.row.disposeStatus == '2' && scope.row.caseStatus != '1'" @click="handleCase(scope.row)" size="small" type="text">结案</el-button>
				</template>
			</myTableSearch>
       </div>
       <viewModal ref="viewModalRef" />
    </div>
</template>

<script>
import '@/assets/css/base.css'
import {getEnterpriseList} from '@/api/unpaidWages/enterprise'
import {getDeptList} from '@/api/public'
import viewModal from '../components/view.vue'


export default {
    name: 'PolicyList',
    components: {
		viewModal,
	},
    data() {
        return {
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50],
				query: {
					createDeptId: this.$store.state.user.currentDeptId || this.$store.state.user.userData.deptId,
				},
			},
			isSubscribeDialog: false,//新增/编辑/查看政策弹窗
			isEdit: false,//是否为编辑模式
			isView: false,//是否为查看模式
			editData: {},//编辑/查看时的数据
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			formData: [
                {
                    label: '企业名称',
                    type: 'input',
                    key: 'comName',
                    colLg: 6,
                    placeholder: '企业名称'
                },
				{
					label: '所属街镇',
					type: 'select',
					key: 'streetId',
					colLg: 6,
					data: []
				},
				{
                    label: '处理状态',
                    type: 'select',
                    key: 'disposeStatus',
                    colLg: 6,
                    data: [
                        {
                            dictLabel: '待处理',
                            dictValue: '0'
                        },
                        {
                            dictLabel: '处理中',
                            dictValue: '1'
                        },
                        {
                            dictLabel: '已处理',
                            dictValue: '2'
                        }
                    ]
                },
                {
                    label: '结案状态',
                    type: 'select',
                    key: 'caseStatus',
                    colLg: 6,
                    data: [
                        {
                            dictLabel: '未结案',
                            dictValue: '0'
                        },
                        {
                            dictLabel: '已结案',
                            dictValue: '1'
                        }
                    ]
                },
                {
                    label: '投诉时间',
                    type:"daterange",
                    key: 'complaintTime',
                    colLg: 6,
                    rangeSeparator: '至',
                    complaintTimeStart: '开始日期',
                    complaintTimeEnd: '结束日期',
                    format: 'yyyy-MM-dd',
                    valueFormat: 'yyyy-MM-dd',
                    screen: (value) => {
                        if (value && value.length === 2) {
                            return {
                                complaintTimeStart: value[0],
                                complaintTimeEnd: value[1]
                            }
                        }
                        return {}
                    }
                }
			],
			tableLabel: [
				{
					prop: 'complaintCode',
					label: '投诉编号',
					minWidth: 150
				},
				{
					prop: 'comName',
					label: '企业名称',
					minWidth: 300
				},
				{
					prop: 'userName',
					label: '投诉人',
					width: 200
				},
				{
					prop: 'userPhone',
					label: '联系电话',
					minWidth: 200
				},
				{
					prop: 'streetName',
					label: '所属街镇',
					width: 100
				},
                {
                    prop: 'wageArrearsStart',
                    label: '欠薪开始时间',
                    width: 180
                },
                {
                    prop: 'wageArrearsEnd',
                    label: '欠薪结束时间',
                    width: 180
                },
                {
                    prop: 'arrearsAmount',
                    label: '欠薪金额(元)',
                    width: 100
                },
                {
                    prop: 'disposeStatus',
                    label: '处理状态',
                    width: 100
                },
                {
                    prop: 'caseStatus',
                    label: '结案状态',
                    width: 100
                },
                {
                    prop: 'complaintTime',
                    label:'提交时间',
                    width: 180
                }
			],
		}
    },
    mounted() {
        this.loadPolicyTagData()
    },
    methods: {
		// 获取列表数据（createDeptId 需放在 query 内；搜索时 myTableSearch 会覆盖 query，这里每次合并）
		queryFn(queryParams) {
			return getEnterpriseList({
				...queryParams,
				query: {
					...(queryParams.query || {}),
				}
			})
		},
		// 获取所属街镇列表
		async loadPolicyTagData() {
			const res = await getDeptList({typeCode:'4'})
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithStreetTag(res.data)
			}
		},
        // 更新所属街镇下拉选项
        updateFormDataWithStreetTag(tagData) {
			if (!tagData || !Array.isArray(tagData)) return

			const tagIndex = this.formData.findIndex(item => item.key === 'streetId')
			if (tagIndex !== -1) {
				// 将接口返回的数据转换为下拉选项格式
				const formattedData = tagData.map(item => ({
					dictLabel: item.deptName,
					dictValue: item.id
				}))
				
				// 在数据开头添加"全部"选项
				const dataWithAll = [
					{
						dictLabel: '全部',
						dictValue: ''
					},
					...formattedData
				]
				this.$set(this.formData[tagIndex], 'data', dataWithAll)
			}
		},

		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},




		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
		// 获取处理状态颜色
		getDisposeStatusColor(status) {
			const colorMap = {
				'0': '#297DEE', // 待处理
				'1': '#FFB322', // 处理中
				'2': '#20C980'  // 已处理
			}
			return colorMap[status] || '#909399'
		},
		// 获取处理状态文本
		getDisposeStatusText(status) {
			const textMap = {
				'0': '待处理',
				'1': '处理中',
				'2': '已处理'
			}
			return textMap[status] || '-'
		},
		// 获取结案状态颜色
		getCaseStatusColor(status) {
			const colorMap = {
				'0': '#FFB322', // 未结案
				'1': '#20C980'  // 已结案
			}
			return colorMap[status] || '#909399'
		},
		// 获取结案状态文本
		getCaseStatusText(status) {
			const textMap = {
				'0': '未结案',
				'1': '已结案'
			}
			return textMap[status] || '-'
		},

        // 查看
        handleView(row) {
            this.$refs.viewModalRef.handleOpen(row)
        },

        // 处理
        handleDispose(row) {
            this.$store.dispatch('enterprise/saveCurrentId', row.id)
            this.$router.push({
                path: '/laborRelations/enterprise/dispose',
            })
        },
        
        //结案审核
        handleCase(row) {
            this.$store.dispatch('enterprise/saveCurrentId', row.id)
            this.$router.push({
                path: '/laborRelations/enterprise/closed',
            })
        },
	},
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .toolbar-icon {
        width: 24px;
        height: 24px;
    }

    .add-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .toolbar-left {
        display: flex;
        align-items: center;
        gap: 12px;
		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}
        .list-title {
            font-size: 14px;
            font-weight: 400;
            color:var(--vt-c-blue-soft);
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .import-upload {
            display: inline-block;
            
            /deep/.el-upload {
                display: inline-block;
            }
        }

        .el-button {
            height: 36px;
            padding: 0 16px;
        }
    }
}
</style>